import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Explore = () => {
    const nav = useNavigate('');
    const [datak, setdata] = useState([]);
    const [end, setend] = useState(6)
    const getData = async () => {
        const apikey = "cYaiLYjQHhOAt8grCTUUaiR9m2J83t0GD7T5YQI2zyKsI1TZuf0MX0tp";
        const app = await fetch("https://api.pexels.com/v1/curated?per_page=15", {
            headers: { Authorization: apikey }
        })

        if (app) {
            let res = await app.json()
            setdata(res.photos)
        }
    }
    const getsrchData = async () => {
        const apikey = "cYaiLYjQHhOAt8grCTUUaiR9m2J83t0GD7T5YQI2zyKsI1TZuf0MX0tp";
        const app = await fetch("https://api.pexels.com/v1/curated?per_page=15", {
            headers: { Authorization: apikey }
        })

        if (app) {
            let res = await app.json()
            setdata(res.photos)
        }
    }

    https://api.pexels.com/v1/search?query=nature&per_page=1
    useEffect(() => {
        getData();
    }, [])

    const more = () => {
        setend(end + 6)
    }
    useEffect(() => {
        getData();
    }, [end])

    return (
        <>

                <div className="container">
            <div className="row">
                    {
                        datak.slice(0, end).map((data, ind) => (
                            <>
                                <div key={ind} id="cardt" className="col-lg-4">
                                    <div> <img onClick={() => nav(`/view?idtb=${data.id}`)} src={data.src.original} className="img-fluid dimg" /> </div>
                                </div>

                            </>
                        ))}
                </div>
            </div>
            <div className="kload">
                <button className='btn btn-primary ' onClick={more}> View More </button>
            </div>
        </>

    );
}

export default Explore;